import { Card, SectionHeader, DeltaChip } from "../../components/lib";
import { ListRow } from "../../components/lib.overlay";
import { LAUNCH_PROJECTS, PRE_ORDERS, SUBSCRIBERS, PRE_LAUNCH_CAMPAIGNS } from "../../mocks/launchData";

export default function LaunchOverview() {
  const totalPipeline = LAUNCH_PROJECTS.reduce((s, l) => s + (l.budgetEGP - l.spentEGP), 0);
  const totalPreOrderRev = PRE_ORDERS.filter((o) => o.status === "confirmed").reduce((s, o) => s + o.amountEGP, 0);
  const totalWaitlist = SUBSCRIBERS.length;
  const activeCampaigns = PRE_LAUNCH_CAMPAIGNS.filter((c) => c.status === "live").length;

  return (
    <div className="space-y-6" data-testid="ln-overview">
      <Card testId="ln-kpis">
        <SectionHeader eyebrow="Overview" title="Launch pipeline health" />
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          <div><div className="text-[10px] uppercase tracking-[0.14em]" style={{ color: "var(--ph-ink-muted)" }}>Active launches</div><div className="text-xl font-semibold tabular-nums mt-1" style={{ color: "var(--ph-ink-strong)" }}>{LAUNCH_PROJECTS.length}</div></div>
          <div><div className="text-[10px] uppercase tracking-[0.14em]" style={{ color: "var(--ph-ink-muted)" }}>Uncommitted budget</div><div className="text-xl font-semibold tabular-nums mt-1" style={{ color: "var(--ph-ink-strong)" }}>EGP {(totalPipeline/1_000_000).toFixed(2)}M</div></div>
          <div><div className="text-[10px] uppercase tracking-[0.14em]" style={{ color: "var(--ph-ink-muted)" }}>Pre-order revenue</div><div className="text-xl font-semibold tabular-nums mt-1 inline-flex items-center gap-2" style={{ color: "var(--ph-success)" }}>EGP {(totalPreOrderRev/1000).toFixed(0)}K <DeltaChip delta={12.4} trend="up" /></div></div>
          <div><div className="text-[10px] uppercase tracking-[0.14em]" style={{ color: "var(--ph-ink-muted)" }}>Waitlist</div><div className="text-xl font-semibold tabular-nums mt-1" style={{ color: "var(--ph-ink-strong)" }}>{totalWaitlist} · {activeCampaigns} live</div></div>
        </div>
      </Card>

      <Card padded={false} testId="ln-list">
        <div className="p-5" style={{ borderBottom: "1px solid var(--ph-border-subtle)" }}>
          <SectionHeader eyebrow="Launches" title={`${LAUNCH_PROJECTS.length} in flight`} />
        </div>
        <div className="p-2">
          {LAUNCH_PROJECTS.map((l) => (
            <ListRow key={l.id} testId={`ln-p-${l.id}`}
              label={<span>{l.productName} · <span className="text-[10px] font-mono" style={{ color: "var(--ph-ink-muted)" }}>{l.sku}</span></span>}
              sublabel={<>{l.phase} · readiness {l.readinessPct}% · target {l.targetDate} · {l.daysToLaunch}d · {l.leadOwner}</>}
              trailing={<div className="text-right">
                <div className="text-sm tabular-nums" style={{ color: "var(--ph-ink-strong)" }}>{l.preOrderCurrentUnits}/{l.preOrderTargetUnits} u</div>
                <div className="text-[10px] tabular-nums" style={{ color: "var(--ph-ai)" }}>AI {Math.round(l.aiConfidence*100)}%</div>
              </div>}
            />
          ))}
        </div>
      </Card>
    </div>
  );
}
